import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { SelectCatalogPage } from '../../pages/profile/SelectCatalogPage';

const _constants = {
  padding: 15,
  leftPadding: 30,
  inputTitleHeight: 40,
};

export class ProfileCatalogBox extends Lightning.Component {
  static _template() {
    return {
      Container: {
        w: w => w,
        h: h => h,
        Title: {
          x: _constants.leftPadding,
          y: _constants.padding,
          h: _constants.inputTitleHeight,
          text: {
            text: 'Catalog',
            ...Theme.Fonts.Normal,
            fontSize: 26,
          },
        },
        SelectedCatalog: {
          mountY: 1,
          x: _constants.leftPadding,
          y: h => h - _constants.padding,
          text: {
            ...Theme.Fonts.Default,
            text: 'selected',
            textColor: 0xffafc0cd,
          },
        },
      },
    };
  }

  _init() {
    this._title = '';
  }

  _focus() {
    this.color = Theme.Colors.ProfilePage.InteractionFocused;
  }

  _unfocus() {
    this.color = Theme.Colors.ProfilePage.InteractionUnfocused;
  }

  _handleEnter() {
    this.fireAncestors(
      '$openDialog',
      {
        type: SelectCatalogPage,
        data: this._catalogs,
        selected: this._currentChannel,
        zIndex: 10002,
        owner: this,
        title: this._title,
      },
      true
    );
  }

  set data(d) {
    this._catalogs = d.catalogs;
    this._data = d.data;
    if (this._data) {
      this._currentChannel = this._catalogs.find(item => item.id === this._data.profile.catalog).name;
    } else {
      this._currentChannel = this._catalogs[0].name;
    }
    this.tag('SelectedCatalog').text.text = this._currentChannel;
    this._title = d.backend.translations.forKey('profile_property_catalog');
    this.tag('Title').text.text = this._title;
    // give options to option select
  }

  updateSelected(val) {
    this._currentChannel = val.text;
    this.tag('SelectedCatalog').text.text = this._currentChannel;
    this.fireAncestors('$closeDialog');
  }

  get selectedChannel() {
    if (this._catalogs && this._currentChannel) {
      return this._catalogs.find(item => item.name === this._currentChannel);
    }
    return undefined;
  }
}
